"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSigningCosmosClientOptions = void 0;
const amino_1 = require("../amino");
const codec_1 = require("../../codec");
const stargate_1 = require("@cosmjs/stargate");
// import { GasPrice } from '@cosmjs/stargate';
const getSigningCosmosClientOptions = () => {
    const registry = codec_1.registry;
    const aminoTypes = amino_1.AminoTypesMap;
    const gasPrice = stargate_1.GasPrice.fromString("0.025uosmo");
    return {
        registry,
        aminoTypes,
        gasPrice,
    };
};
exports.getSigningCosmosClientOptions = getSigningCosmosClientOptions;
